import { render, staticRenderFns } from "./committee-member.vue?vue&type=template&id=5e424b26&"
import script from "./committee-member.vue?vue&type=script&lang=js&"
export * from "./committee-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports